import tkTaskViewService from "../../../services/tkTaskViewService";
import h from "../../../services/h";
import constants from "../../../constants";
import moment from "moment";
import qs from "qs";
export default {
  props: [
    "keyword",
    "taskStatuses",
    "sort",
    "order",
    "usingAdvanceSearch",
    "advanceSearchForm",
    "viewType"
  ],

  data() {
    return {
      settings: {
        maxScrollbarLength: 550
      },
      tasks: [],
      tasksCount: null,
      page: 0,
      size: 10,
      TASK_STATUS: constants.TASK_STATUS
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    convertLinkToDetail(item) {
      let params = {
        fromStartDate: this.$route.query.fromStartDate,
        toStartDate: this.$route.query.toStartDate,
        taskStatusFilter: this.$route.query.taskStatusFilter || 'all',
        viewType: this.$route.query.viewType
      };
      return `${window.location.origin}/#/app/${this.$store.getters.userDeptRoleId}/job/${params.viewType === constants.JOB_INDEX_PAGE.VIEW_TYPE.COORDINATOR ? 'coordinate' : 'dept_assigned'}/detail/${item.id}?${this.formatQuery(params)}`;
    },

    stopProcess(e) {
      e.preventDefault();
    },

    formatQuery(params) {
      return qs.stringify(params, {
        arrayFormat: "repeat"
      });
    },
    /**
     * lv1: qua han, lv2: sap toi han, lvl3: chua toi han;
     * @param deadline
     * @returns {string}
     */
    getDeadlineLvlClass(deadline) {
      if (!deadline) return "";
      let date = new moment(deadline).startOf("date");
      let now = new moment().startOf("date");
      let diff = date.diff(now, "days");
      return diff >= 3 ? "lv3" : diff < 3 && diff >= 0 ? "lv2" : "lv1";
    },

    watchDetail(tkTask) {
      this.$emit("viewDetail", { tkTask: tkTask });
    },

    doSort(sort) {
      let order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.$emit("doSort", { order: order, sort: sort });
    },

    doSearch() {
      this.tasks = [];
      this.page = 0;
      this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
    },

    infiniteHandler($state) {
      this.listTask().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    listTask() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      return (this.viewType === constants.JOB_INDEX_PAGE.VIEW_TYPE.COORDINATOR
        ? tkTaskViewService.findAllCoordinated(this.advanceSearchForm, pageable)
        : tkTaskViewService.findAllTasksInDept(this.advanceSearchForm, pageable)
      ).then(response => {
        let items = response.data;
        items && (this.tasks = this.tasks.concat(items));
        return items;
      });
    },

    getEvaluationPointLabel(evaluationPoint) {
      let point = h.find(
        constants.EVALUATION_POINT,
        point => point.score === evaluationPoint
      );
      return point ? point.value : null;
    },

    getTaskStatusLabel(taskStatus) {
      switch (taskStatus) {
        case constants.TASK_STATUS.HUY:
          return "Hủy";
        case constants.TASK_STATUS.TAM_DUNG:
          return "Tạm dừng";
        default:
          return null;
      }
    },

    getPriorityClass(name) {
      switch (name) {
        case "Cao":
          return "lv1";
        case "Trung bình":
          return "lv2";
        case "Bình thường":
          return "lv2";
        case "Thấp":
          return "lv3";
        default:
          return "lv3";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/job/components/mainContentCoordinateMixin.js